(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dibao-series-reveal')) {
    class DibaoSeriesReveal extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.list = this.querySelector('[data-series-list]');
        this.button = this.querySelector('[data-series-toggle]');
        if (!this.list || !this.button || this.list.classList.contains('slider')) return;

        this.items = Array.from(this.list.children).filter((item) =>
          item.classList.contains('collection-list__item'),
        );
        this.label = this.button.querySelector('[data-series-toggle-label]');
        this.expanded = false;
        this.handleToggle = this.handleToggle.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.button.addEventListener('click', this.handleToggle);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        window.addEventListener('resize', this.handleResize, { passive: true });
        this.dataset.initialized = 'true';
        this.sync();
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.handleToggle);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        window.removeEventListener('resize', this.handleResize);
        if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
        delete this.dataset.initialized;
      }

      getVisibleLimit() {
        const limit = Number.parseInt(getComputedStyle(this).getPropertyValue('--series-visible-limit'), 10);
        return Number.isFinite(limit) ? limit : 3;
      }

      sync() {
        const limit = this.getVisibleLimit();
        const hasOverflow = this.items.length > limit;

        this.items.forEach((item, index) => {
          item.hidden = hasOverflow && !this.expanded && index >= limit;
        });

        this.button.hidden = !hasOverflow;
        this.button.setAttribute('aria-expanded', String(hasOverflow && this.expanded));
        this.dataset.expanded = String(hasOverflow && this.expanded);
        if (this.label) {
          this.label.textContent = this.expanded ? this.button.dataset.lessLabel : this.button.dataset.moreLabel;
        }
      }

      handleToggle() {
        if (!this.expanded) {
          const firstHiddenItem = this.items.find((item) => item.hidden);
          this.expanded = true;
          this.sync();
          if (firstHiddenItem) {
            requestAnimationFrame(() => {
              const links = Array.from(firstHiddenItem.querySelectorAll('a[href]'));
              const firstLink = links.find((link) => link.getClientRects().length > 0) || links[links.length - 1];
              if (firstLink) firstLink.focus({ preventScroll: true });
              firstHiddenItem.scrollIntoView({ block: 'nearest', behavior: 'auto' });
            });
          }
          return;
        }

        const buttonTop = this.button.getBoundingClientRect().top;
        this.expanded = false;
        this.sync();
        const nextButtonTop = this.button.getBoundingClientRect().top;
        window.scrollBy(0, nextButtonTop - buttonTop);
        this.button.focus({ preventScroll: true });
      }

      handleResize() {
        if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => this.sync());
      }

      handleBlockSelect(event) {
        const item = event.target.closest('.collection-list__item');
        if (!item || !this.contains(item) || !item.hidden) return;
        this.expanded = true;
        this.sync();
      }
    }

    customElements.define('dibao-series-reveal', DibaoSeriesReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
